import { render, staticRenderFns } from "./UserModule.vue?vue&type=template&id=0a54435d&scoped=true"
import script from "./UserModule.vue?vue&type=script&lang=js"
export * from "./UserModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a54435d",
  null
  
)

export default component.exports